// Create a simple path alias to allow browserify to resolve
// the runtime on a supported path.
module.exports = require('./dist/cjs/handlebars.runtime')['default'];



//////////////////
// WEBPACK FOOTER
// ./~/handlebars/runtime.js
// module id = 3
// module chunks = 0 1 3 4 5 6